// extracted by mini-css-extract-plugin
module.exports = {"modalContainer":"PriceChangesAvailabilityModal_modalContainer__v8kJb","modalContent":"PriceChangesAvailabilityModal_modalContent___Pnwc"};